module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.onCreate()
      }
    }
  }, [_vm._v("Create")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-right": "0px",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "col-sm-3 col-md-3"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    attrs: {
      "for": "pagesize"
    }
  }, [_vm._v("Show")]), _vm._v(" "), _c('select', {
    ref: "recordPerPage",
    staticClass: "form-control",
    attrs: {
      "id": "pagesize"
    },
    on: {
      "change": _vm.changePageSize
    }
  }, [(_vm.inquiryParam.pageSize == 5) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("5")]) : _c('option', [_vm._v("5")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 10) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("10")]) : _c('option', [_vm._v("10")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 20) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("20")]) : _c('option', [_vm._v("20")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 50) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("50")]) : _c('option', [_vm._v("50")]), _vm._v(" "), (_vm.inquiryParam.pageSize == 100) ? _c('option', {
    attrs: {
      "selected": ""
    }
  }, [_vm._v("100")]) : _c('option', [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9 col-md-9 has-feedback"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search by company name"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.onSearch($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon ion-search form-control-feedback"
  })])])])])])])]), _vm._v(" "), _vm._l((_vm.listData), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "container-fluid"
    }, [(i % 4 === 0) ? _c('div', {
      staticClass: "row"
    }, [(_vm.listData[i] != undefined) ? _c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12",
      on: {
        "click": function($event) {
          _vm.onDisplay(_vm.listData[i])
        }
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "padding": "5px",
        "border-color": "#d9d7d7",
        "border": "1px solid #d9d7d7"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('img', {
      staticClass: "attachment-img",
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "src": '/image/Company/' + _vm.listData[i].imageUrl + '?' + Date.now(),
        "alt": "Company Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "text-align": "left",
        "margin-left": "70px"
      }
    }, [_c('span', {
      staticClass: "info-box-text",
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(_vm.listData[i].name))]), _vm._v(" "), _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm.listData[i].description))])])])]) : _vm._e(), _vm._v(" "), (_vm.listData[i + 1] != undefined) ? _c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12",
      on: {
        "click": function($event) {
          _vm.onDisplay(_vm.listData[i + 1])
        }
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "padding": "5px",
        "border-color": "#d9d7d7",
        "border": "1px solid #d9d7d7"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('img', {
      staticClass: "attachment-img",
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "src": '/image/Company/' + _vm.listData[i + 1].imageUrl + '?' + Date.now(),
        "alt": "Company Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "text-align": "left",
        "margin-left": "70px"
      }
    }, [_c('span', {
      staticClass: "info-box-text",
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(_vm.listData[i + 1].name))]), _vm._v(" "), _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm.listData[i + 1].stock))])])])]) : _vm._e(), _vm._v(" "), (_vm.listData[i + 2] != undefined) ? _c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12",
      on: {
        "click": function($event) {
          _vm.onDisplay(_vm.listData[i + 2])
        }
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "padding": "5px",
        "border-color": "#d9d7d7",
        "border": "1px solid #d9d7d7"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('img', {
      staticClass: "attachment-img",
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "src": '/image/Company/' + _vm.listData[i + 2].imageUrl + '?' + Date.now(),
        "alt": "Company Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "text-align": "left",
        "margin-left": "70px"
      }
    }, [_c('span', {
      staticClass: "info-box-text",
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(_vm.listData[i + 2].name))]), _vm._v(" "), _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm.listData[i + 2].stock))])])])]) : _vm._e(), _vm._v(" "), (_vm.listData[i + 3] != undefined) ? _c('div', {
      staticClass: "col-md-3 col-sm-6 col-xs-12",
      on: {
        "click": function($event) {
          _vm.onDisplay(_vm.listData[i + 3])
        }
      }
    }, [_c('div', {
      staticClass: "info-box",
      staticStyle: {
        "padding": "5px",
        "border-color": "#d9d7d7",
        "border": "1px solid #d9d7d7"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left"
      }
    }, [_c('img', {
      staticClass: "attachment-img",
      staticStyle: {
        "width": "64px"
      },
      attrs: {
        "src": '/image/Company/' + _vm.listData[i + 3].imageUrl + '?' + Date.now(),
        "alt": "Company Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info-box-content",
      staticStyle: {
        "text-align": "left",
        "margin-left": "70px"
      }
    }, [_c('span', {
      staticClass: "info-box-text",
      staticStyle: {
        "text-transform": "none"
      }
    }, [_vm._v(_vm._s(_vm.listData[i + 3].name))]), _vm._v(" "), _c('span', {
      staticClass: "info-box-number"
    }, [_vm._v(_vm._s(_vm.listData[i + 3].stock))])])])]) : _vm._e()]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row pull-right"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "right"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-rewind",
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber - 1)
      }
    }
  })])]), _vm._v(" "), _c('label', [_vm._v("\n              Page\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inquiryParam.CurrentPageNumber),
      expression: "inquiryParam.CurrentPageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "margin-left": "5px",
      "margin-right": "5px"
    },
    attrs: {
      "id": "CurrentPage"
    },
    domProps: {
      "value": (_vm.inquiryParam.CurrentPageNumber)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.gotoPage($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.inquiryParam, "CurrentPageNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "id": "TotalPageText"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.totalPages) + "                \n          ")]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "35px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-right-b",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.inquiryParam.CurrentPageNumber + 1)
      }
    }
  })])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "width": "25px",
      "text-align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "icon ion-ios-fastforward",
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPages)
      }
    }
  })])])])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6048dc78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Company.vue
// module id = 782
// module chunks = 1